import Carousel from '../Carousel/Carousel';
import CourseCard from '../CourseCard/CourseCard';
import { CourseCardProps } from '../CourseCard/CourseCard.types';
import LayoutContainer from '../../../common/Layout/Layout';
import styles from '../CourseCard/CourseCard.module.scss';
import { CY_SUGGESTED_TRAINING } from '../../../../lib/constants/cypress';

export type SuggestedTrainingViewItems = {
  id?: string;
  href: string;
} & CourseCardProps;

type SuggestedTrainingViewProps = {
  id: string;
  title?: string;
  items: SuggestedTrainingViewItems[];
};

const SuggestedTrainingView = ({ id, title, items }: SuggestedTrainingViewProps) => (
  <LayoutContainer>
    <Carousel id={id} title={title} slidesPerView={3} ariaLabel="Suggested training" data-cy={CY_SUGGESTED_TRAINING}>
      {items.map(({ id: cardId, ...props }) => (
        <CourseCard
          elementsClasses={{ root: styles.cardMargin, image: styles.imageCarouselAspectRatio }}
          key={cardId}
          id={cardId}
          {...props}
          progress={undefined}
          imageFullWidth
        />
      ))}
    </Carousel>
  </LayoutContainer>
);

export default SuggestedTrainingView;
